import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_TEST_SCHEDULES } from '@/api/endpoints';
import { TEST_SCHEDULES_QUERY_KEY } from '@/api/queryKeys';
import type { TestScheduleDay } from '@/types/scheduledTests';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useTestSchedules = (enabled: boolean) =>
  useQuery<TestScheduleDay[]>({
    queryKey: TEST_SCHEDULES_QUERY_KEY,
    enabled,
    queryFn: () =>
      apiClient
        .get<TestScheduleDay[]>(API_TEST_SCHEDULES)
        .then(unwrapAxiosResponse),
  });
